'use strict';

function prepMessageData(event) {
    var isCorrectObject = event.data.hasOwnProperty('first_name') &&
        event.data.hasOwnProperty('last_name') &&
        event.data.hasOwnProperty('email') &&
        event.data.hasOwnProperty('cell_phone') &&
        event.data.hasOwnProperty('answers');

    if (isCorrectObject) {
        window.setClientDetails(
            event.data.first_name,
            event.data.last_name,
            event.data.email,
            event.data.cell_phone,
            event.data.answers,
        );
    }
}
window.addEventListener("message", prepMessageData, false);


function createSetClientDetails(appointment) {

    window.setClientDetails = function(firstName, lastName, emailAddress, cellNumber, answers) {
        var client = {
            first_name: firstName,
            last_name: lastName,
            email: emailAddress,
            cell_phone: cellNumber,
        };

        appointment.set('client', [client]);
        appointment.set('answers', answers);
    }
}

export default createSetClientDetails;
